import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './store';
import './index.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import App from './App';
import * as serviceWorker from './serviceWorker';
import Loader from './components/Shared/loader';
import axios from 'axios';
import { toastr } from "react-redux-toastr";



const store = configureStore();

const AppWithInterceptors = () => {
  const [loading, setLoading] = useState(false);

  const showSpinner = () => {
    setLoading(true);
  };

  const hideSpinner = () => {
    setLoading(false);
  };

  useEffect(() => {
    // Inject Authorization header for all fetch calls to /chatbot
    const originalFetch = window.fetch?.bind(window);
    if (originalFetch) {
      window.fetch = async (input, init = {}) => {
        try {
          const url = typeof input === 'string' ? input : input?.url || '';
          if (url && url.includes('/chatbot')) {
            const token = localStorage.getItem('session');
            
            // Prevent API call if user is not authenticated
            if (!token) {
              console.warn('Chatbot API call blocked: User is not authenticated');
              throw new Error('User not authenticated. Please log in to use the chatbot.');
            }
            
            // Ensure we do not send undefined org id
            if (url.includes('/api/undefined/chatbot')) {
              const orgRaw = localStorage.getItem('org');
              let orgId = null;
              try {
                if (orgRaw) orgId = JSON.parse(orgRaw)?._id || null;
              } catch (e) {}
              const vendorId = sessionStorage.getItem('vendorId');
              const safeOrg = orgId || vendorId || '65741905f25d82d21ced1abd';
              input = url.replace('/api/undefined/chatbot', `/api/${safeOrg}/chatbot`);
            }
            const headers = new Headers(init.headers || {});
            if (token && !headers.has('Authorization')) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            if (!headers.has('Content-Type')) {
              headers.set('Content-Type', 'application/json');
            }
            const newInit = { ...init, headers };
            return originalFetch(input, newInit);
          }
        } catch (e) {
          // fall through and use original fetch
        }
        return originalFetch(input, init);
      };
    }

    const requestInterceptor = axios.interceptors.request.use((config) => {
      // Show spinner for all requests except save-response and question-forms
      if (!config.url.includes('/save-response') && !config.url.includes('/question-forms/')) {
        showSpinner();
      }
      return config;
    });

    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        // Hide spinner for all requests except save-response and question-forms
        if (!response.config.url.includes('/save-response') && !response.config.url.includes('/question-forms/')) {
          hideSpinner();
        }
        if (response?.status === 401 || response?.data?.status === '401') {
          toastr.success("Error", response.data.userMessage);
          window.location.reload()
          localStorage.clear()
          sessionStorage.clear()
          window.location.replace("/login");
        }
        return response;
      },
      (error) => {
        hideSpinner();
        return Promise.reject(error);
      }
    );

    return () => {
      if (originalFetch) {
        window.fetch = originalFetch;
      }
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []); 

  // Simple app content without unnecessary wrappers
  return (
    <Provider store={store}>
      {loading && <Loader />}
      <App />
    </Provider>
  );
};

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<AppWithInterceptors />);
}

serviceWorker.unregister();
